module.exports = __webpack_public_path__ + "assets/images/chef_02_551af4d9f033a3bbe0cea7d8df19a42f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/chef_02.png
// module id = 184
// module chunks = 0